export default __webpack_public_path__ + "static/media/hp-plans-guided-histories-img.a9f6a93a.svg";